import { Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { PlannerService } from '../api/planner.service';
import { LocalstorageService } from './localstorage.service';
import { USER_ID } from '@algomusinc/domain';
@Injectable({
  providedIn: 'root'
})
export class ProfileService {
public PLANNER_CONFIG = {
  LABELS: {ItemLabel: '', AccountLabel: '', TimeFrameLabel: '', DistributorLabel: '', ForecastTimeFrame: ''},
  ITEMS: new Array(),
  ACCOUNTS: new Array(),
  CALENDAR: new Array(),
  ITEM_HIERARCHY: new Array(),
  ACCOUNT_HIERARCHY: new Array(),
  CALENDAR_HIERARCHY: new Array(),

  ITEM_HIERARCHY_DICTIONARY: {} as { [key: string]: any },
  ACCOUNT_HIERARCHY_DICTIONARY: {} as { [key: string]: any },
  CALENDAR_HIERARCHY_DICTIONARY: {} as { [key: string]: any },

  ACTIVE_COMBINATIONS: new Array(),
  ITEM_LEVELS: new Array(),
  ACCOUNT_LEVELS: new Array()
}
constructor(public config: ConfigurationService, public plannerService: PlannerService, public storage: LocalstorageService) { }
  public async setPlannerConfig(fbTemplateId: number, IsLeafSelectable?: boolean) {
    await this.setClientAlias().catch(err => new Error(err));
    await this.setCalendar().catch(err => new Error(err));
    await this.setAccounts().catch(err => new Error(err));
    // await this.setItems().catch(err => new Error(err));
    if (IsLeafSelectable) {
      await this.setLeafSelectable(fbTemplateId, IsLeafSelectable)
    }
    else { 
      await this.setHierarchies(fbTemplateId).catch(err => new Error(err)); 
    }
    
  }
  public async setAccounts() {
    const params = {
      offset: 0,
      pageSize: 100000,
      active: true,
    };

    let url = `offSet=${params.offset ? params.offset : 0}&pageSize=${ params.pageSize ? params.pageSize : 10}&active=true`;

    if (this.PLANNER_CONFIG.ACCOUNTS.length == 0) {
      const accountRes = await firstValueFrom(this.config.ItemAccountGetAll(url));
      this.PLANNER_CONFIG.ACCOUNTS = accountRes.data || [];
    }
  }
  public async setItems() {
    const params = {
      offset: 0,
      pageSize: 100000,
      active: true,
    };

    let url = `offSet=${params.offset ? params.offset : 0}&pageSize=${ params.pageSize ? params.pageSize : 10}&active=true`;
    if (this.PLANNER_CONFIG.ITEMS.length == 0) {
      const itemRes = await firstValueFrom(this.config.ItemManagerGetAll(url));
      this.PLANNER_CONFIG.ITEMS = itemRes.data || [];
    }
  }
  public async setHierarchies(fbTemplateId: number) {
    const tasks = new Array();
    if (
      !(fbTemplateId in this.PLANNER_CONFIG.ITEM_HIERARCHY_DICTIONARY) || 
      !(fbTemplateId in this.PLANNER_CONFIG.ACCOUNT_HIERARCHY_DICTIONARY) || 
      !(fbTemplateId in this.PLANNER_CONFIG.CALENDAR_HIERARCHY_DICTIONARY)) {
      // Hierarchy Not Loaded for Current Planner  
      tasks.push(this.config.ItemHierarchyGetAllTree({fbTemplateId: fbTemplateId , userId:  this.storage.get(USER_ID) }));
      tasks.push(this.config.AccountHierarchyGetAllTree({fbTemplateId: fbTemplateId, userId: this.storage.get(USER_ID) }))
      tasks.push(this.config.CalendarHierarchyGetAll({fbTemplateId: fbTemplateId}))
    }
     const res: Array<string> | any = await firstValueFrom(forkJoin(tasks)).catch(error => new Error(error));
      if (res && res.length) {
        res.forEach((response: string, index: number) => {
          let _parsed = JSON.parse(response);
          if (index == 0) {
            this.PLANNER_CONFIG.ITEM_HIERARCHY_DICTIONARY[fbTemplateId] = _parsed;
          } else if (index == 1) {
            this.PLANNER_CONFIG.ACCOUNT_HIERARCHY_DICTIONARY[fbTemplateId] = _parsed;
          } else {
            this.PLANNER_CONFIG.CALENDAR_HIERARCHY_DICTIONARY[fbTemplateId] = _parsed;
          }
        })
      }
  }
  public async setLeafSelectable(fbTemplateId: number, IsLeafSelectable: boolean) {
    const tasks = new Array();
    if (
      (!(fbTemplateId in this.PLANNER_CONFIG.ITEM_HIERARCHY_DICTIONARY) || 
      !(fbTemplateId in this.PLANNER_CONFIG.ACCOUNT_HIERARCHY_DICTIONARY)) && IsLeafSelectable
    ) {
      tasks.push(this.config.ItemHierarchyGetAllTree({fbTemplateId: fbTemplateId ,  userId: this.storage.get(USER_ID), IsLeafSelectable: IsLeafSelectable}));
      tasks.push(this.config.AccountHierarchyGetAllTree({fbTemplateId: fbTemplateId,  userId: this.storage.get(USER_ID), IsLeafSelectable: IsLeafSelectable}))
      }
     const res: Array<string> | any = await firstValueFrom(forkJoin(tasks)).catch(error => new Error(error));
      if (res && res.length) {
        res.forEach((response: string, index: number) => {
          let _parsed = JSON.parse(response);
          if (index == 0) {
            this.PLANNER_CONFIG.ITEM_HIERARCHY_DICTIONARY[fbTemplateId] = _parsed;
          } else if (index == 1) {
            this.PLANNER_CONFIG.ACCOUNT_HIERARCHY_DICTIONARY[fbTemplateId] = _parsed;
          }
        })
      }
  }
  public async setClientAlias() {
    if (!(this.PLANNER_CONFIG.LABELS.ItemLabel)) {
      const labels = await firstValueFrom(this.config.GetClientAliasString({}));
      const parsedLabels = JSON.parse(labels);
      if (parsedLabels.ItemLabel) {
        this.PLANNER_CONFIG.LABELS = parsedLabels;
      }
    }
  }
  public async setCalendar() {
    const calendarRes: Array<any> = await firstValueFrom(this.plannerService.calendarGetList({}));
    this.PLANNER_CONFIG.CALENDAR = calendarRes;
  }
}
